import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@environments/environment';

import {
  AssetAnalytics,
  CandidatureInvoiceGroup,
  CandidatureStats,
  GeneralAnalytics,
  InvoiceGroup,
  SlaStats,
  UserAnalytics
} from '../../models';

@Injectable()
export class AnalyticsApiService {
  url: string;
  homeownersRawData: Map<string, UserAnalytics[]> = new Map();
  selectedUserAnalytics: UserAnalytics;
  dateFiltered: string;

  constructor(private http: HttpClient) {
    this.url = environment.services.analytics;
  }

  getGeneralAnalyticsByDefault(
    requestDate?: string
  ): Observable<GeneralAnalytics[]> {
    if (requestDate) {
      return this.http.get<GeneralAnalytics[]>(
        this.url + '/generalAnalytics/byRangeDate?fromDate=' + requestDate
      );
    } else {
      return this.http.get<GeneralAnalytics[]>(
        this.url + '/generalAnalytics/byRangeDate'
      );
    }
  }

  getAllUsersResume(requestDate?: string): Observable<UserAnalytics[]> {
    if (requestDate) {
      return this.http.get<UserAnalytics[]>(
        this.url + '/userAnalytics/byRangeDate?fromDate=' + requestDate
      );
    } else {
      return this.http.get<UserAnalytics[]>(
        this.url + '/userAnalytics/byRangeDate'
      );
    }
  }

  getHomeownerSales(
    homeownerId: string,
    requestDate: string
  ): Observable<AssetAnalytics[]> {
    return this.http.get<AssetAnalytics[]>(
      this.url +
        '/userAnalytics/byHomeowner?fromDate=' +
        requestDate +
        '&homeownerId=' +
        homeownerId
    );
  }

  updateInvoiceStatus(invoicedList: unknown[]): Observable<unknown> {
    return this.http.patch(
      environment.services.users + '/requests-analysis/invoiced',
      invoicedList
    );
  }

  getCandidatureByInvoiceGroup(
    month: string,
    year: string
  ): Observable<CandidatureInvoiceGroup[]> {
    const endpoint = `${this.url}/candidature/invoice-group`;
    const params = new HttpParams().append('month', month).append('year', year);
    return this.http.get<CandidatureInvoiceGroup[]>(endpoint, { params });
  }

  updateCandidatureByInvoiceGroupAsInvoiced(
    group: string,
    year: number,
    month: number
  ): Observable<boolean> {
    const request = {
      invoiceGroup: group,
      year: year,
      month: month
    };
    return this.http.post<boolean>(
      this.url + `/candidature/mark-as-invoiced`,
      request
    );
  }

  getCandidatureAnalytics(
    fromMonth: number,
    fromYear: number,
    portfolioId?: string
  ): Observable<CandidatureStats[]> {
    const endpoint = `${this.url}/candidature/from-year-month`;
    let params = new HttpParams()
      .append('fromYear', fromYear)
      .append('fromMonth', fromMonth);

    if (portfolioId) {
      params = params.append('portfolioId', portfolioId);
    }
    return this.http.get<CandidatureStats[]>(endpoint, { params });
  }

  getGroups(): Observable<InvoiceGroup[]> {
    const endpoint = `${this.url}/candidature/invoiced-groups`;
    return this.http.get<InvoiceGroup[]>(endpoint);
  }

  getSla(): Observable<SlaStats[]> {
    const endpoint = `${this.url}/candidature/sla-backoffice`;
    const params = new HttpParams()
      .append('fromYear', (new Date().getFullYear() - 1).toString())
      .append('fromMonth', (new Date().getMonth() + 1).toString());
    return this.http.get<SlaStats[]>(endpoint, { params });
  }
}
